import styled from "styled-components";

import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const EmploymentPeriodField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const EmploymentPeriodWarning = styled.p`
  ${TypographyV2.s1}
  background-color: ${ColorV2.UnplannedAbsenceYellow};
  border-radius: 8px;
  color: ${ColorV2.Blue2};
  margin: 0;
  padding: 8px 10px;
`;
